import { render, staticRenderFns } from "./Prazos.vue?vue&type=template&id=34f6ec69&scoped=true"
import script from "./Prazos.vue?vue&type=script&lang=js"
export * from "./Prazos.vue?vue&type=script&lang=js"
import style0 from "./Prazos.vue?vue&type=style&index=0&id=34f6ec69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f6ec69",
  null
  
)

export default component.exports